/**
 * @author: lv.chen
 * @date: 2026/5/18
 * @desc: ColumnAligner 组件演示文件，展示对齐方式、气泡提示、高亮颜色等配置效果
 */
import React from 'react';
import ColumnAligner from './index';

/**
 * Demo 案例配置
 * 每个配置项对应文档页面中的一个演示场景
 */
export const demoConfig = [
  {
    title: '基础用法 - 左对齐',
    description: '默认左对齐，宽度 140px',
    code: `<ColumnAligner align="left" width={140}>
  游戏名称
</ColumnAligner>`,
    element: (
      <div style={{ border: '1px solid #ddd', padding: '12px 20px' }}>
        <ColumnAligner align="left" width={140}>
          游戏名称
        </ColumnAligner>
      </div>
    ),
  },
  {
    title: '居中对齐',
    description: '设置 align="center" 使列标题居中显示',
    code: `<ColumnAligner align="center" width={200}>
  上线时间
</ColumnAligner>`,
    element: (
      <div style={{ border: '1px solid #ddd', padding: '12px 20px' }}>
        <ColumnAligner align="center" width={200}>
          上线时间
        </ColumnAligner>
      </div>
    ),
  },
  {
    title: '右对齐',
    description: '设置 align="right" 使列标题右对齐，适用于数值列',
    code: `<ColumnAligner align="right" width={160}>
  收入(美元)
</ColumnAligner>`,
    element: (
      <div style={{ border: '1px solid #ddd', padding: '12px 20px' }}>
        <ColumnAligner align="right" width={160}>
          收入(美元)
        </ColumnAligner>
      </div>
    ),
  },
  {
    title: '三种对齐方式对比',
    description: '同时展示 left、center、right 三种对齐效果',
    code: `<ColumnAligner align="left" width={140}>左对齐</ColumnAligner>
<ColumnAligner align="center" width={140}>居中</ColumnAligner>
<ColumnAligner align="right" width={140}>右对齐</ColumnAligner>`,
    element: (
      <div
        style={{
          display: 'flex',
          border: '1px solid #ddd',
          padding: '12px 20px',
          gap: '20px',
        }}
      >
        <ColumnAligner align="left" width={140}>
          左对齐
        </ColumnAligner>
        <ColumnAligner align="center" width={140}>
          居中
        </ColumnAligner>
        <ColumnAligner align="right" width={140}>
          右对齐
        </ColumnAligner>
      </div>
    ),
  },
  {
    title: '带气泡提示',
    description: '配置 hoverTipsKey 后，hover 时显示国际化气泡提示',
    code: `<ColumnAligner align="left" width={180} hoverTipsKey="dbi_table_column_tips">
  活跃用户
</ColumnAligner>`,
    element: (
      <div style={{ border: '1px solid #ddd', padding: '12px 20px' }}>
        <ColumnAligner
          align="left"
          width={180}
          hoverTipsKey="dbi_table_column_tips"
        >
          活跃用户
        </ColumnAligner>
      </div>
    ),
  },
  {
    title: '高亮标题颜色',
    description: '设置 useHighlightTitleColor=true 启用高亮颜色，可自定义 highlightTitleColor',
    code: `<ColumnAligner
  align="left"
  width={160}
  useHighlightTitleColor
  highlightTitleColor="#ff6b35"
>
  重点指标
</ColumnAligner>`,
    element: (
      <div style={{ border: '1px solid #ddd', padding: '12px 20px' }}>
        <ColumnAligner
          align="left"
          width={160}
          useHighlightTitleColor
          highlightTitleColor="#ff6b35"
        >
          重点指标
        </ColumnAligner>
      </div>
    ),
  },
  {
    title: '宽度 100%',
    description: 'width 设置为 "100%" 时，内容撑满容器宽度，不做减法处理',
    code: `<ColumnAligner align="center" width="100%">
  撑满宽度标题
</ColumnAligner>`,
    element: (
      <div style={{ border: '1px solid #ddd', padding: '12px 20px' }}>
        <ColumnAligner align="center" width="100%">
          撑满宽度标题
        </ColumnAligner>
      </div>
    ),
  },
];

export default demoConfig;
